__webpack_require__.p = "https://parcelhub.ae/accounting/statisticals/";